<template lang="pug">
  div
    div.logo    
    div.icontainer
      div.user
      h1 {{ $t('welcome-message') }}
      p.ml-2 {{ $t('welcome-text') }}
      v-row
        v-col(:cols="1")
          div.check
        v-col(:cols="11")
          p.lh {{ $t('check-1') }}
      v-row
        v-col(:cols="1")
          div.check
        v-col(:cols="11")
          p.lh {{ $t('check-2') }}
      hr
      h1.mt-5 {{ $t('nufi-customer') }}
      p {{ $t('nufi-customer-text') }}
      v-btn(@click="toLogin").white.primary--text {{ $t('login') }} 
</template>
<script>
export default {
  methods: {
    toLogin() {
      window.location.replace(process.env.VUE_APP_NUFILOGINURL);
    }
  },
}
</script>
<style lang="scss" scoped>
  .logo {
    background-image: url('../assets/logo_nufi_blanco-08.svg');
    width: 200px;
    height: 100px;
    float: right;
  }
  .user {
    width: 50px;
    height: 50px;
    background-image: url('../assets/icono_usuario-09.svg');
  }
  .check {
    width: 40px;
    height: 40px;
    background-image: url('../assets/palomita-06.svg');
    background-size: cover;
  }
  p.lh {
    line-height: 40px;
  }
  .icontainer {
    padding-left: 20%;
    padding-right: 20%;
    padding-top: 10%;
  }  

</style>